import React from "react";
//components
import { Space } from "./styles";
import { DropdownArrow } from "./DropdownArrow";
import { Visibility } from "components/Visibility";
//interfaces
import { ITableDropdown } from "./interface";

export const TableDropdown: React.FC<ITableDropdown> = (props) => {
  const {
    data,
    index,
    isRanking,
    orderStatus,
    renderButton,
    colorRowTable,
    expandedDropdown,
    DropdownTemplate,
    setExpandedDropdown,
    conditionalStatusSent
  } = props;

  return (
    DropdownTemplate ?
      <>
        <Visibility visible={!conditionalStatusSent && !orderStatus}>
          <Space expandedDropdown={expandedDropdown} setExpandedDropdown={setExpandedDropdown} className={`${!isRanking && colorRowTable!(index)}`} />
        </Visibility>
        <Visibility visible={!!conditionalStatusSent || !!orderStatus}>
          <DropdownArrow expandedDropdown={expandedDropdown} setExpandedDropdown={setExpandedDropdown} data={data} renderButton={renderButton} colorRowTable={colorRowTable} index={index} />
        </Visibility>
      </>
      : null
  );
};